<template>
  <div class="cmp-tab-wrap" :class="{'mobile':_isMobile}">
    <div ref="myTab" class="cmp-tab" :class="{'pc': !_isMobile}">
      <div class="item g-pointer" :class="{'active': activeTab===item.val}" v-for="(item, index) in tabList" :key="index" @click="clickTab(item, index)">{{item.name}}</div>

      <!-- 占位 勿删  解决h5右边没间距问题 -->
      <div class="item item-end" v-if="_isMobile">&nbsp;</div>

      <div class="tab-line"></div>
      <!-- <div class="tab-line" :style="{height: 'calc(100vh - '+subHeight+')'}"></div> -->
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      tabs: {
        type: Array,
        default() {
          return []
        }
      },
      subHeight: {
        type: String,
        default: '760px'
      },
      activeVal: {
        type: String,
        default: '1'
      }
    },
    watch: {
      tabs(newVal) {
        this.tabList = newVal
      },
      activeVal(newVal) {
        this.activeTab = newVal
      }
    },
    data() {
      return {
        activeTab: this.activeVal || '1',
        tabList: this.tabs,
        currentIndex: 0
        // tabList: [
        //   {
        //     name: '展厅实景',
        //     val: '1',
        //   },
        //   {
        //     name: '展品详情',
        //     val: '2'
        //   }
        // ],
      }
    },
    methods: {
      clickTab(item, index) {
        if(this.activeTab !== item.val) {
          this.currentIndex = index
          this.activeTab = item.val
          this.$emit('eventTabClick', item.val, index)
          this.getTabItemWidth()
        }
      },
      // 获取左移动位置
      getTabItemWidth() {
        let arr = this.$refs.myTab.getElementsByClassName('item')
        let lineLeft = 0  // 前面的宽度总和
        let currentWidth = 0 // 当前元素宽度
        for (let i = 0; i < arr.length; i++) {
          if (i < this.currentIndex) {
            lineLeft += arr[i].clientWidth
          } else if (i == this.currentIndex) {
            currentWidth = arr[i].clientWidth
          } else {
            break
          }
        }

        lineLeft = lineLeft + currentWidth / 2
        let containerWidth = this.$refs.myTab.clientWidth
        let scrollLeft = lineLeft - containerWidth / 2 + 80

        // console.log(lineLeft)
        // console.log(containerWidth)
        // console.log(scrollLeft)
        this.$refs.myTab.scrollLeft = scrollLeft
      }
    }
  }
</script>

<style lang="scss" scoped>
.cmp-tab {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #3D3D3D;
  white-space: nowrap;
  overflow-x: auto;
  // border-top: solid 1px rgba(#000000, 0.1);
  border-bottom: solid 1px rgba(#000000, 0.1);
  padding: 26px 0;
  // margin-bottom: 30px;
  .item {
    padding: 5px 0;
    margin-right: 60px;
    // margin-right: 50px;
    border-bottom: solid 2px transparent;
    border-width: 0;
    cursor: pointer;
    font-weight: bold;
    &:after {
      display: block;
      content: '';
      width: 0;
      height: 2px;
      background: $primary;
      transition: all .2s ease-in;
      position: relative;
      top: 31px;
    }
    &:hover{
      color: $primary;
    }
    &.active {
      color: $primary;
      // border-bottom: solid 2px gray;
      border-width: 100%;
      &:after {
        width: 100%;
      }
    }
  }

  &::-webkit-scrollbar {  
    display: none;
  }   
}
</style>